import { render, staticRenderFns } from "./DealHeader.vue?vue&type=template&id=7d80649e"
import script from "./DealHeader.vue?vue&type=script&lang=js"
export * from "./DealHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports